import React from "react";
import Navbar from "./components/navbar";
import CreateAcincoComponent from "./create/create.component";
import CreateAcincoProvider from "./create/provider/createAcinco.provider";
import CreateUsedAcincoProvider from "./create/used/provider/createUsedAcinco.provider";
import CreateNewsAcincoProvider from "./create/news/provider/createNewsAcinco.provider";

const AcincoPage = () => {
  return (
    <CreateAcincoProvider>
      <CreateNewsAcincoProvider>
        <CreateUsedAcincoProvider>
          <div className="h-screen overflow-auto bg-gradient-to-b from-white to-[#0082CB]">
            <Navbar />
            <section className="flex h-full w-full items-center justify-center p-0">
              <div className="container mb-auto mt-auto w-full px-4 lg:px-20">
                <CreateAcincoComponent />
              </div>
            </section>
          </div>
        </CreateUsedAcincoProvider>
      </CreateNewsAcincoProvider>
    </CreateAcincoProvider>
  );
};

export default AcincoPage;
